import React from 'react';
import { useNavigate } from 'react-router-dom';

export const PropertyFooter = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  
  return (
    <footer className="bg-foreground text-background py-8 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-background/60">
          <div className="text-center sm:text-left">
            <p>© {currentYear} Urban Oasis LLC. All rights reserved. | An <a href="https://offworldventures.org" target="_blank" rel="noopener noreferrer" className="hover:text-background transition-smooth underline">Offworld Ventures</a> Sanctuary</p>
            <p className="mt-1">Property Managed by <a href="https://propr.pt" target="_blank" rel="noopener noreferrer" className="hover:text-background transition-smooth underline">Propr</a> - Guests please contact your Propr Host for prompt assistance</p>
          </div>
          <div className="flex gap-6">
            <button onClick={() => navigate('/privacy')} className="hover:text-background transition-smooth">Privacy Policy</button>
            <button onClick={() => navigate('/contact')} className="hover:text-background transition-smooth">Contact Us</button>
            <button onClick={() => navigate('/terms')} className="hover:text-background transition-smooth">Terms of Service</button>
          </div>
        </div>
      </div>
    </footer>
  );
};